import { Component, OnInit, Input } from '@angular/core';
import { City, OtEvent } from 'src/app/domain/ot-event';

@Component({
  selector: 'app-ot-breadcrumbs',
  templateUrl: './ot-breadcrumbs.component.html',
  styleUrls: ['./ot-breadcrumbs.component.scss']
})
export class OtBreadcrumbsComponent implements OnInit {

  locations = {
    visible: true,
    active: false
  };

  otEvents = {
    visible: false,
    active: false
  };

  price = {
    visible: false,
    active: false
  };

  person = {
    visible: false,
    active: false
  };

  summary = {
    visible: false,
    active: false
  };

  success = { visible: false };

  private _state: string;
  private _otEvent: OtEvent;

  @Input()
  set state(state: string) {
    this._state = state;
    this.stateChanged();
  }

  @Input()
  city: City;

  @Input()
  set otEvent(otEvent: OtEvent) {
    this._otEvent = otEvent;
    this.stateChanged();
  };
  get otEvent(): OtEvent {
    return this._otEvent;
  }

  get state(): string {
    return this._state;
  }

  constructor() { }

  ngOnInit() {
  }

  private stateChanged(): void {
    this.locations.visible = true;
    this.locations.active = false;
    this.otEvents.visible = false;
    this.otEvents.active = false;
    this.price.visible = false;
    this.price.active = false;
    this.person.visible = false;
    this.person.active = false;
    this.summary.visible = false;

    if (! this._state) {
      return;
    }

    if (this._state === 'locations') {
      this.locations.active = true;
      return;
    }

    if (this._state === 'success') {
      this.success.visible = true;
      return;
    }

    this.otEvents.visible = true;
    if (this._state === 'otEvents') {
      this.otEvents.active = true;
      return;
    }

    this.price.visible = true;
    if (this._state === 'price') {
      this.price.active = true;
      return;
    }

    if (this.otEvent && !this.otEvent.pricing) {
      this.price.visible = false;
    }

    this.person.visible = true;
    if (this._state === 'person') {
      this.person.active = true;
      return;
    }

    this.summary.visible = true;
  }
}
